/**
 * Youth environment boundary.
 *
 * Any route matched here is used by children or students. No third-party
 * tracking (GTM, Meta Pixel, GA, Clarity, ad tags) may load or fire on them.
 *
 * The same pattern is duplicated as a plain string in index.html so GTM is
 * never injected on a hard load of a youth page. Keep both in sync.
 */

export const YOUTH_PATH_PATTERN =
  /^\/(dashboard\/(child|student)|student-access)(\/|$)/

export function isYouthPath(pathname) {
  return YOUTH_PATH_PATTERN.test(pathname || '')
}

export function isYouthEnvironment() {
  if (typeof window === 'undefined' || !window.location) return false
  return isYouthPath(window.location.pathname)
}

/**
 * Use instead of react-router `navigate` whenever moving between an adult
 * route and a youth route (either direction). A full document load makes
 * sure the destination page starts without any tracker already in memory,
 * and that the adult side gets its trackers back.
 */
export function crossYouthBoundary(path, { replace = false } = {}) {
  if (typeof window === 'undefined' || !window.location) return
  if (replace) {
    window.location.replace(path)
  } else {
    window.location.assign(path)
  }
}
